var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconListBullets = function SvgIconListBullets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8.25 5a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zM8.25 11a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zM7.25 18a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2h-12a1 1 0 0 1-1-1M5.625 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M5.625 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconListBullets;